<!-- PROGRESS SPINNER -->
<div *ngIf="sitesLoading || sitesOnlineDevicesLoading || vctLoadingSitesList" class="flex align-items-center justify-content-center w-full pb-8 mt-8">
	<p-progressSpinner ariaLabel="loading"></p-progressSpinner>
</div>
<div *ngIf="!sitesLoading && !sitesOnlineDevicesLoading && !vctLoadingSitesList && onExtendedMobile()" class="flex justify-content-center align-items-center text-xl font-bold">
	{{ 'SITES_MANAGEMENT' | translate }}
</div>
<div *ngIf="!sitesLoading && !sitesOnlineDevicesLoading && !vctLoadingSitesList" class="layout-content px-2 pt-3" [ngClass]="layoutMarginResponsive()">
	<!-- FILTER -->
	<app-sites-cards-filters 
		[siteFilters]="siteFilter"
		[isImpers]="isImpersMode"
		[currentUser]="currentUser"
		(createSiteClicked)="createSite()"
		>
	</app-sites-cards-filters>
	<!-- CONTENT -->
	<div class="grid" [class]="onTablet() ? 'flex justify-content-center px-2' : ''">
		<div *ngIf="sites === undefined || sites.length === 0" class="col-12 flex align-items-center justify-content-center bg-blue-200 p-1 border-round-xl">
			<i class="pi cm-info text-lg text-primary"></i>
			<p-tag [value]="('NO_SITE_CREATED_ALERT' | translate)" severity="info" styleClass="text-lg"></p-tag>
		</div>
		<div *ngFor="let site of sitesOrder" [class]="onExtendedMobile() ? 'w-full' : 'mx-2'">
			<!-- MOBILE -->
			<app-site-card-mobile *ngIf="onExtendedMobile()" [site]="site"></app-site-card-mobile>

			<!-- DESKTOP -->
			<app-site-card-desktop-tablet *ngIf="!onExtendedMobile()" [site]="site"></app-site-card-desktop-tablet>
		</div>
	</div>
</div>